import { Modal, Button } from "react-bootstrap";

const NotificationModal = ({ show, onHide, notification }) => {
  if (!notification) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{notification.title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0">{notification.message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotificationModal;
